import { useMutation } from '@tanstack/react-query';
import unassignTCAPUser from '@/API/TCAPUser/unassignTCAPUser';

import { toast } from 'react-toastify';

const useUnassignTCAPUser = ({
    tcapUserId,
    platformUserId,
    accountScope,
    refetchPlatformUsers,
}) => {
    return useMutation({
        mutationFn: async () => {
            try {
                await unassignTCAPUser({
                    tcapUserId: tcapUserId,
                    platformUserId: platformUserId,
                    scope: accountScope,
                });
                await refetchPlatformUsers();
                toast.success('Unlinked Platform User!');
            } catch (error) {
                const errorMessage =
                    error?.response?.data?.message ||
                    'Failed to unlink platform user';
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
    });
};

export default useUnassignTCAPUser;
